import { render } from "./TestDetail.vue?vue&type=template&id=ce327790"
import script from "./TestDetail.vue?vue&type=script&lang=js"
export * from "./TestDetail.vue?vue&type=script&lang=js"

import "./TestDetail.vue?vue&type=style&index=0&id=ce327790&lang=css"
script.render = render

export default script